/** Export can stop a timer even when later billing validation fails. */
export const EXPORT_SETTLED_EVENT = "hourglass:export_settled";

export function notifyExportSettled(exportedIds: string[]): void {
	window.dispatchEvent(
		new CustomEvent(EXPORT_SETTLED_EVENT, { detail: { exportedIds } }),
	);
}
